import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./motion";
import { FAQS } from "@/data/siteData";

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="bg-mist py-20 lg:py-28">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="text-center">
            <p className="text-brand font-semibold text-sm tracking-wide uppercase">FAQ</p>
            <h2 className="font-display font-bold text-ink tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.1]">
              Frequently asked questions
            </h2>
          </div>
        </Reveal>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.04}>
                <div data-testid={`faq-item-${i}`} className={`card-soft !shadow-none hover:!shadow-none hover:!translate-y-0 overflow-hidden ${isOpen ? "ring-1 ring-brand/20" : ""}`}>
                  <button data-testid={`faq-toggle-${i}`} onClick={() => setOpen(isOpen ? -1 : i)} className="w-full flex items-center justify-between gap-5 text-left px-6 py-5">
                    <span className={`font-display font-semibold text-base sm:text-lg ${isOpen ? "text-brand" : "text-ink"}`}>{f.q}</span>
                    <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.25 }} className={`shrink-0 h-8 w-8 rounded-full flex items-center justify-center ${isOpen ? "bg-accent text-white" : "bg-brand/10 text-brand"}`}>
                      <Plus size={18} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }} className="overflow-hidden">
                        <p className="text-slate2 text-sm sm:text-base leading-relaxed px-6 pb-6">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
